import React from 'react';
import ReactDOM from 'react-dom/client';
import Quiz from './Quiz/Quiz';
// import Home from './MobCompare/Home';
// import Routing from './ContextApi/Routing';
// import Movies from './MoviesWeb/Movies';
// import Routing from './Routing/routing';
// import Cart from './Cart/cart';
// import Axios from './Axios/Axios';
// import {Todo} from "./To-do/Todo"
// import Tesla from "./Tesla/Tesla"
// import Tabs from "./button/tabs"




const root = ReactDOM.createRoot(document.getElementById('root'))


root.render(
   // <Todo/>                                   
   // <Tesla/>
   // <Axios/>
   // <Tabs/>
   // <Cart/>
   // <Routing/>
   // <Movies/>
   // <Routing/>
   // <Home/>
   <Quiz/>
);




